import { left, right } from '../../Either/dist/effect-Either.esm.js';
import { dual } from '../../Function/dist/effect-Function.esm.js';
import { flatMap, zipRight, succeed as succeed$1, map } from './core.esm.js';
import { flatten, collect, fromEither } from './stm.esm.js';
import { get, set, make as make$1 } from './tRef.esm.js';
import { isSome, some, none, match } from '../../Option/dist/effect-Option.esm.js';

/** @internal */
const TDeferredSymbolKey = "effect/TDeferred";

/** @internal */
const TDeferredTypeId = /*#__PURE__*/Symbol.for(TDeferredSymbolKey);

/** @internal */
const tDeferredVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
class TDeferredImpl {
  [TDeferredTypeId] = tDeferredVariance;
  constructor(ref) {
    this.ref = ref;
  }
}

/** @internal */
const _await = self => flatten(collect(get(self.ref), option => isSome(option) ? some(fromEither(option.value)) : none()));

/** @internal */
const done = /*#__PURE__*/dual(2, (self, either) => flatMap(get(self.ref), match({
  onNone: () => zipRight(set(self.ref, some(either)), succeed$1(true)),
  onSome: () => succeed$1(false)
})));

/** @internal */
const fail = /*#__PURE__*/dual(2, (self, error) => done(self, left(error)));

/** @internal */
const make = () => map(make$1(none()), ref => new TDeferredImpl(ref));

/** @internal */
const poll = self => get(self.ref);

/** @internal */
const succeed = /*#__PURE__*/dual(2, (self, value) => done(self, right(value)));

export { TDeferredTypeId, _await, done, fail, make, poll, succeed };
